export default "__VITE_ASSET__Dnvw09Qz__"